export const Leaderboard = [
    {
        name: "Brandon",
        time: "15:00",
        floors: 33,
        steps: 577,
        burned: 165,
        speed: 2.9,
        heartrateaverage: 156,
        heartratemax: 174,
        met: 6.5,
        watts: 178
    },
    {
        name: "Quincy",
        time: "15:02",
        floors: 26,
        steps: 453,
        burned: 94,
        speed: 2.3,
        heartrateaverage: 158,
        heartratemax: 161,
        met: 4.4,
        watts: 73
    },
    {
        name: "Sebastine",
        time: "10:02",
        floors: 23,
        steps: 406,
        burned: 80,
        speed: 3.1,
        heartrateaverage: 172,
        heartratemax: 201,
        met: 3.5,
        watts: 52
    },
    {
        name: "Soham",
        time: "20:01",
        floors: 36,
        steps: 628,
        burned: 130,
        speed: 2.4,
        heartrateaverage: 134,
        heartratemax: 140,
        met: 4.8,
        watts: 82
    }
]